module.exports = __webpack_public_path__ + "static/media/IndieFlower.cbd50882.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/IndieFlower.ttf
// module id = 728
// module chunks = 0